import React, { useEffect, useState } from 'react'
import Panel from '../../components/Panel'
import Table, { TableColumnConfig } from '../../components/Table/Table'
import Badge from '../../components/Badge'
import { getProgramsApi } from '../../apis/apis'
import type { ProgramItem } from '../../apis/types'
import { formatUTCDate } from '../../util/string'

interface PropertyProgramsPanelProps {
  propertyId: string
}

type ProgramItemWithId = ProgramItem & { id: string }

const colConfig: Array<TableColumnConfig<ProgramItemWithId>> = [
  {
    label: 'Program Name',
    render: (row) => row.name,
  },
  {
    label: 'Utility',
    render: (row) => row.utility,
  },
  {
    label: 'Start Date',
    render: (row) => formatUTCDate(row.startDate),
  },
  {
    label: 'PTO Date',
    render: (row) => formatUTCDate(row.ptoDate),
  },
  {
    label: 'VNEM Billing Active',
    render: (row) => <Badge status={row.billingOn ? 'YES' : 'NO'} className="justify-center" />,
  },
]

/**
 * Read-only list of programs associated with this property. Placeholder for other
 * property-level info panels to grow alongside (per coworker feedback).
 */
const PropertyProgramsPanel: React.FC<PropertyProgramsPanelProps> = ({ propertyId }) => {
  const [programs, setPrograms] = useState<ProgramItem[] | null>(null)

  useEffect(() => {
    setPrograms(null)
    void getProgramsApi({ propertyId, page: 0, resultsPerPage: 50 }).then((res) => setPrograms(res.results))
  }, [propertyId])

  const rows: ProgramItemWithId[] = (programs ?? []).map((p) => ({ ...p, id: p.id }))

  return (
    <Panel header="Programs at this Property">
      {programs == null ? (
        <div className="text-sm text-slate-500 dark:text-slate-400">Loading programs...</div>
      ) : rows.length === 0 ? (
        <div className="py-4 text-sm text-slate-600 dark:text-slate-400">No programs are associated with this property.</div>
      ) : (
        <Table
          colConfig={colConfig}
          data={{ results: rows, total: rows.length, page: 0, resultsPerPage: rows.length }}
          getRowHref={(row) => `/program/programs/${row.id}`}
          hidePaginator
        />
      )}
    </Panel>
  )
}

export default PropertyProgramsPanel
